module.exports = __webpack_public_path__ + "img/vape-shop-custom-website-img-5.14f8f41b.jpeg";